import { Route } from 'types/route.type';
import ScenarioPlanStepOverview from 'views/playground/features/bluviu-nutrition-r2/components/scenario-plan-step-overview';

export const routes: Route[] = [
  {
    path: '/playground/bluviu-nutrition-r2',
    component: ScenarioPlanStepOverview,
  },
];
